import React from 'react';
import { useAuth, type EnterpriseAccess } from '../../context/AuthContext';
import { useDashboard } from '../../context/DashboardContext';
import { effectiveAccess } from '../../hooks/useEntitlements';
import { t } from '../../utils/translations';
import { SubscriptionCard } from '../SubscriptionCard';
import type { UserSession } from '../../types';

// Écran « essai gratuit terminé — choisir une formule » (#20).
// Free = 30 jours PAR ENTREPRISE (trial_end), puis blocage COMPLET : le SERVEUR décide
// (api.get_user_enterprise / api.get_enterprise_access rendent access_mode 'locked' via
// api.enterprise_access_locked ; les fonctions edge refusent 403 trial_expired). Ici on ne fait
// que REFLÉTER cette décision : l'écran remplace toute page des gardes de route (App.tsx), sans
// barre latérale ni menu — seulement le choix d'une formule (paiement Stripe) et la déconnexion.
// Après paiement, CheckoutReturnHandler relit le forfait → access_mode redevient 'full'.

/** Pur. Accès de l'entreprise SÉLECTIONNÉE s'il est connu, sinon 1re adhésion (effectiveAccess).
 *  Super-admin : jamais bloqué (ses droits ne dépendent d'aucune entreprise). */
export function isAccessLocked(
  user: UserSession | null | undefined,
  active: EnterpriseAccess | null | undefined,
): boolean {
  if (!user?.loggedIn || user.role === 'superadmin') return false;
  return effectiveAccess(user, active).access_mode === 'locked';
}

export const TrialExpiredScreen: React.FC = () => {
  const { logout } = useAuth();
  const { language } = useDashboard();
  return (
    <div className="login-page" data-testid="trial-expired-screen">
      <div className="login-card" style={{ maxWidth: 760, width: '100%' }}>
        <h1 className="login-title">{t(language, 'trialExpiredTitle')}</h1>
        <p style={{ textAlign: 'center', color: 'var(--gray-600)', marginBottom: 8 }}>{t(language, 'trialExpiredBody')}</p>
        <p style={{ textAlign: 'center', fontWeight: 600, marginBottom: 20 }}>{t(language, 'trialExpiredChoosePlan')}</p>
        {/* Choix de formule + paiement : même carte que Paramètres ▸ Facturation (serveur revérifie le droit de payer). */}
        <SubscriptionCard />
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => { void logout(); }}>
            {t(language, 'trialExpiredLogout')}
          </button>
        </div>
      </div>
    </div>
  );
};
